<template>
  <div>
    <slot></slot>
    <div ref="script-container"></div>
  </div>
</template>

<script>
  export default {
    mounted() {
      const scriptMain = document.createElement('script')
      scriptMain.setAttribute('type', 'text/javascript')
      scriptMain.setAttribute('src', 'https://www.e-podroznik.pl/public/jslib.do')

      this.$refs['script-container'].appendChild(scriptMain)

    }
  }
</script>

<style lang="less">

</style>
